import React from 'react';
import { Typography, Box } from '@mui/material';
import MarkEmailReadOutlinedIcon from '@mui/icons-material/MarkEmailReadOutlined';

const Welcome = ({ currentInbox, theme }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100%',
        textAlign: 'center',
        p: 3,
        position: 'relative',
        overflow: 'hidden',
        '&::before': {
          content: '""',
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          backgroundImage: `radial-gradient(${theme.palette.action.hover} 1px, transparent 1px)`,
          backgroundSize: '20px 20px',
          opacity: 0.3,
          zIndex: 0,
        },
      }}
    >
      <Box sx={{ position: 'relative', zIndex: 1 }}>
        <MarkEmailReadOutlinedIcon sx={{ fontSize: '6rem', color: 'primary.main', mb: 2, opacity: 0.8 }} />
        <Typography variant="h4" component="h2" sx={{ fontWeight: 600, mb: 1 }}>
          {currentInbox ? 'Inbox is Empty' : 'Welcome to Mailinator'}
        </Typography>
        <Typography variant="body1" color="text.secondary">
          {currentInbox
            ? <>Send an email to <strong style={{ color: theme.palette.primary.main }}>{currentInbox}</strong> and it will appear here.</>
            : 'Enter an inbox name above to view emails, or generate a random one.'}
        </Typography>
      </Box>
    </Box>
  );
};

export default Welcome;
